export const EXPENDITURE_FORM_DATA = 'EXPENDITURE_FORM_DATA';
export const EXPENDITURE_DROP_DATA = 'EXPENDITURE_DROP_DATA';
export const EXPENDITURE_LIST_DATA = 'EXPENDITURE_LIST_DATA';
export const BANK_ACCOUNTS_LIST = 'BANK_ACCOUNTS_LIST';
export const EXEMPT_LIST_DATA = 'EXEMPT_LIST_DATA';
export const EXEMPT_PLAN_SINGLE = 'EXEMPT_PLAN_SINGLE';
